import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const RESTORE_SERVER_DATA = 'RESTORE_SERVER_DATA';
export const CLEAR_COMPLETED_SAVE_SETTINGS = 'CLEAR_COMPLETED_SAVE_SETTINGS';
export const UPDATE_NO_SHOW_BEHAVIOUR_REQUEST = 'UPDATE_NO_SHOW_BEHAVIOUR_REQUEST';
export const UPDATE_NO_SHOW_BEHAVIOUR_SUCCESS = 'UPDATE_NO_SHOW_BEHAVIOUR_SUCCESS';
export const UPDATE_NO_SHOW_BEHAVIOUR_FAILURE = 'UPDATE_NO_SHOW_BEHAVIOUR_FAILURE';

export const HIDE_NON_WORKING_STYLIST_COLUMN_REQUEST = 'HIDE_NON_WORKING_STYLIST_COLUMN_REQUEST';
export const HIDE_NON_WORKING_STYLIST_COLUMN_SUCCESS = 'HIDE_NON_WORKING_STYLIST_COLUMN_SUCCESS';
export const HIDE_NON_WORKING_STYLIST_COLUMN_FAILURE = 'HIDE_NON_WORKING_STYLIST_COLUMN_FAILURE';

export const TOGGLE_DEPOSIT_PROMPT_REQUEST = 'TOGGLE_DEPOSIT_PROMPT_REQUEST';
export const TOGGLE_DEPOSIT_PROMPT_SUCCESS = 'TOGGLE_DEPOSIT_PROMPT_SUCCESS';
export const TOGGLE_DEPOSIT_PROMPT_FAILURE = 'TOGGLE_DEPOSIT_PROMPT_FAILURE';

export const SET_SAVED_FALSE = 'SET_SAVED_FALSE';

export const setSavedFalse = () => ({ type: SET_SAVED_FALSE });
export const restoreServerData = () => ({ type: RESTORE_SERVER_DATA, meta: { analytics: EventTypes.track } });

export const updateSalonDetails = (salon) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salon.id}/`,
    authenticated: true,
    params: { noshow_behaviour: salon.noshow_behaviour },
    types: [UPDATE_NO_SHOW_BEHAVIOUR_REQUEST, UPDATE_NO_SHOW_BEHAVIOUR_SUCCESS, UPDATE_NO_SHOW_BEHAVIOUR_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(salon),
    },
  },
});

export const hideNonWorking = (salonId, hideNonWorkingStylistColumn) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/`,
    authenticated: true,
    types: [HIDE_NON_WORKING_STYLIST_COLUMN_REQUEST, HIDE_NON_WORKING_STYLIST_COLUMN_SUCCESS, HIDE_NON_WORKING_STYLIST_COLUMN_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hide_non_working_stylist_column: hideNonWorkingStylistColumn }),
    },
  },
});

export const toggleRequestDepositPrompt = (salonId, hideOrShow) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/`,
    authenticated: true,
    types: [TOGGLE_DEPOSIT_PROMPT_REQUEST, TOGGLE_DEPOSIT_PROMPT_SUCCESS, TOGGLE_DEPOSIT_PROMPT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ request_deposit_prompt: hideOrShow }),
    },
  },
});
